import React from 'react'
import DatesTable from './components/DateTable/DatesTable'
import Title from '../../../components/Title/Title'
import { importantDates2023 } from '../../../common/constants/importantDates'

const ImportantDates2023page = () => {
  return (
    <>
      <Title>Important Dates</Title>
      <DatesTable array={importantDates2023} />
    </>
  )
}

export default ImportantDates2023page;
